import { render, staticRenderFns } from "./ProductOptionsCard.vue?vue&type=template&id=2c8c54b2&scoped=true"
import script from "./ProductOptionsCard.vue?vue&type=script&lang=js"
export * from "./ProductOptionsCard.vue?vue&type=script&lang=js"
import style0 from "./ProductOptionsCard.vue?vue&type=style&index=0&id=2c8c54b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c8c54b2",
  null
  
)

export default component.exports